import _objectSpread2 from "../_virtual/_@oxc-project_runtime@0.150.0/helpers/esm/objectSpread2.js";
import { transportItemTypeToBodyKey } from "./const.js";
//#region src/transports/utils.ts
function mergeResourceSpans(traces, resourceSpans) {
	var _traces$resourceSpans, _resourceSpans$;
	if (resourceSpans === void 0) return traces;
	if (traces === void 0) return { resourceSpans };
	const currentResource = (_traces$resourceSpans = traces.resourceSpans) === null || _traces$resourceSpans === void 0 ? void 0 : _traces$resourceSpans[0];
	if (currentResource === void 0) return traces;
	const currentSpans = (currentResource === null || currentResource === void 0 ? void 0 : currentResource.scopeSpans) || [];
	const newSpans = (resourceSpans === null || resourceSpans === void 0 || (_resourceSpans$ = resourceSpans[0]) === null || _resourceSpans$ === void 0 ? void 0 : _resourceSpans$.scopeSpans) || [];
	return _objectSpread2(_objectSpread2({}, traces), {}, { resourceSpans: [_objectSpread2(_objectSpread2({}, currentResource), {}, { scopeSpans: [...currentSpans, ...newSpans] })] });
}
function getTransportBody(item) {
	let body = { meta: {} };
	if (item[0] !== void 0) body.meta = item[0].meta;
	item.forEach((currentItem) => {
		switch (currentItem.type) {
			case "log":
			case "event":
			case "exception":
			case "measurement": {
				const bk = transportItemTypeToBodyKey[currentItem.type];
				const signals = body[bk];
				body = _objectSpread2(_objectSpread2({}, body), {}, { [bk]: signals === void 0 ? [currentItem.payload] : [...signals, currentItem.payload] });
				break;
			}
			case "trace": body = _objectSpread2(_objectSpread2({}, body), {}, { traces: mergeResourceSpans(body.traces, currentItem.payload.resourceSpans) });
		}
	});
	return body;
}
//#endregion
export { getTransportBody, mergeResourceSpans };

//# sourceMappingURL=utils.js.map